import http from "../http-common-2";

class WorkshopService {
  getAllWorkshops(token: any) {
    return http.get(`/workshops/all`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  getAllUpcomingWorkshops(token: any) {
    return http.get(`/workshops`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }
  getParticipants(id: string) {
    return http.get(`/workshops/${id}/participants`);
  }
}
export default new WorkshopService();